import React from "react";
import "../../css/SecondarySchoolSection.css";
import { Link } from "react-router-dom";
import SchoolHero from "./SchoolHero";
import ParentTestimonials from "../ParentTestimonials";
import WhyChooseUs from "../WhyChooseUs";

const SecondarySchoolSection = () => {
  const secondaryImg = "./images/g.jpeg";

  return (
    <>
      <SchoolHero
        title="Secondary School"
        subtitle="Building strong foundations for lifelong learning."
        image="/images/ff.jpeg"
      />

      <section className="secondary-school-container">
        <div className="ss-main-card">
          <div className="ss-flex-layout">
            <div className="ss-info-box">
              <div className="ss-orange-header">
                <h2>Secondary School</h2>
              </div>

              <div className="ss-content-body">
                <div className="ss-meta">
                  <span>
                    <strong>Grade 6 to 10</strong>
                  </span>

                  <span className="ss-status">
                    <i className="ss-check">✔</i>
                    Enrolling Now
                  </span>
                </div>

                <p className="ss-desc-text">
                  Our programme for primary years is designed to be a joyful
                  experience for students between 5.5 to 11.5 years, an age
                  where physical and mental growth is accelerated and all
                  encompassing.
                  <br />
                  <br />
                  At this critical juncture, our faculty step in to identify,
                  nurture and grow the students academic and non-academic
                  interests in such a way that information passed to them is
                  measured and engaging, making the learning of the rigorous{" "}
                  <span className="ss-link">SEEB curriculum</span> a fun and
                  joyful experience.
                </p>
              </div>

              <div className="ss-bottom-nav">
                <div className="ss-nav-item">
                  <Link to="/book-meeting">🤝 BOOK A MEETING</Link>
                </div>

                <div className="ss-nav-item">
                  <Link to="/admissionenquiryform">📄 ADMISSION FORM</Link>
                </div>

                <div className="ss-nav-item">
                  <Link to="/feestructure">💵 FEES</Link>
                </div>
              </div>
            </div>

            <div className="ss-image-box">
              <img
                src={secondaryImg}
                alt="Secondary School"
                className="ss-hero-img"
              />
            </div>
          </div>
        </div>
      </section>
      <ParentTestimonials />
      <WhyChooseUs />
    </>
  );
};

export default SecondarySchoolSection;
